import { ApprovalSettingName } from '@/features/public/settingApproval/types/ApprovalSettingName.ts';

export const approvalSettingNameLabels: Record<ApprovalSettingName, string> = {
  [ApprovalSettingName.SENDER_FROM_EMAIL]: 'Adres nadawcy',
  [ApprovalSettingName.REPLY_TO_EMAIL]: 'Adres Reply-To',
};

export const getApprovalSettingNameLabel = (settingName: string): string => {
  return (
    approvalSettingNameLabels[settingName as ApprovalSettingName] ?? settingName
  );
};
